/** @jsxImportSource react */
import { recordEntityCta } from '@common/helpers/localStorage';
import redirectToHomebase from '@react/cta/helpers/redirectToHomebase';
import ConversionWizard from '@react/gwizzy/components/ConversionWizard';
import {
  ASSESSMENT_WIZARD_COMPLETED,
  ASSESSMENT_WIZARD_COMPLETED_COMMUNITIES,
} from '@sly/core/constants/assessment';
import { memo } from 'react';

function InlineConversionWizard({
  community,
  eventProps,
  mode,
  showLocationStep,
  submitText = '',
  skipHomebaseRedirect = false,
  conversionSchemaOverride = 'gwizzy',
}) {
  const conversionDone = (values, isSignUpSuccessfull) => {
    if (community) {
      const { id } = community;
      recordEntityCta(ASSESSMENT_WIZARD_COMPLETED_COMMUNITIES, id);
    }

    localStorage.setItem(
      ASSESSMENT_WIZARD_COMPLETED,
      ASSESSMENT_WIZARD_COMPLETED
    );

    if (isSignUpSuccessfull && !skipHomebaseRedirect) {
      redirectToHomebase(community?.name, {
        entry: community ? 'communityPricing' : 'generalOptions',
      });
      return;
    }
  };

  return (
    <ConversionWizard
      community={community}
      ctaActions={{ conversionDone }}
      eventProps={eventProps}
      mode={mode}
      showLocationStep={showLocationStep}
      conversionSchemaOverride={conversionSchemaOverride}
      submitTextCTA={submitText}
      isInline
    />
  );
}

export default memo(InlineConversionWizard);
